import { render, staticRenderFns } from "./annualEducationPlan.vue?vue&type=template&id=139b790c"
import script from "./annualEducationPlan.vue?vue&type=script&lang=js"
export * from "./annualEducationPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('139b790c')) {
      api.createRecord('139b790c', component.options)
    } else {
      api.reload('139b790c', component.options)
    }
    module.hot.accept("./annualEducationPlan.vue?vue&type=template&id=139b790c", function () {
      api.rerender('139b790c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/annual/annualEducationPlan.vue"
export default component.exports